module.exports = {
  DUE: 'due',
  PENDING: 'pending',
  DONE: 'done',
  FAILED: 'failed'
}
